import axiosClient from '../axiosClient';

const messageService = {
  async getMessages(params = {}) {
    try {
      const response = await axiosClient.get('/messages', { params });
      return response.data.data;
    } catch (error) {
      return Promise.reject(
        error.response?.data?.message || 'errors.failed_to_fetch_messages'
      );
    }
  },

  async exportMessages(params = {}) {
    try {
      const response = await axiosClient.get('/messages/export', {
        params,
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      return Promise.reject(
        error.response?.data?.message || 'errors.failed_to_export_messages'
      );
    }
  },

  async deleteMessage(id) {
    try {
      const response = await axiosClient.delete(`/messages/${id}`);
      return response.data;
    } catch (error) {
      return Promise.reject(
        error.response?.data?.message || 'errors.failed_to_delete_message'
      );
    }
  }
};

export default messageService;
